<div class="row margin-bottom">
  <div class="col-md-12">
    <a class="btn button-default" [routerLink]="['/sites/list']"><i class="fa fa-chevron-left text-positive"></i>back to sites list</a>
  </div>
</div>
<hub-site-detail-overview></hub-site-detail-overview>
<hub-site-detail-areas></hub-site-detail-areas>
<hub-site-detail-staff></hub-site-detail-staff>
